import { CouriersData, OrdersData } from 'models/operation-data';
import moment from 'moment';
import { AnyAction, Reducer } from 'redux';

import {
  GET_OPERATION_DATA,
  GET_OPERATION_DATA_ERROR,
  SET_BICYCLES_VISIBILITY,
  SET_CARS_VISIBILITY,
  SET_MOTORCYCLES_VISIBILITY,
  SET_COURIERS_VISIBILITY,
  SET_OPERATION_DATA,
  SET_OPERATION_TAB,
  SET_ORDERS_VISIBILITY,
  TOGGLE_OPERATION,
  TOGGLE_OPERATION_AUTOREFRESH,
  SET_WALKING_VISIBILITY
} from './operation.types';
import { Visibility, SKVisibility } from 'models/redux/operation.state';
import { OperationType } from 'models/operation-type';
import { AutoRefreshModel } from 'models/autorefresh';

export interface OperationState {
  couriersData?: CouriersData;
  couriersUpdate: boolean;
  loadingCouriers: boolean;
  couriersVisibility: {
    walking: SKVisibility;
    bicycle: SKVisibility;
    motorcycle: SKVisibility;
    car: SKVisibility;
  };

  ordersData?: OrdersData;
  loadingOrders: boolean;
  ordersVisibility: Visibility;

  operationTypes: Array<OperationType>;
  tabSelected: number;
  interval: any;

  autoRefresh: {
    couriers: AutoRefreshModel;
    orders: AutoRefreshModel;
  };
}

const initialState: OperationState = {
  couriersData: undefined,
  ordersData: undefined,
  couriersUpdate: false,
  loadingCouriers: false,
  loadingOrders: false,
  ordersVisibility: {
    visible: true,
    levels: {
      noIterationsVisible: true,
      normalVisible: true,
      moderateVisible: true,
      criticalVisible: true,
      deadVisible: true
    }
  },
  couriersVisibility: {
    walking: {
      visible: true,
      levels: {
        freeVisible: true,
        singleOrderVisible: true,
        busyVisible: true,
        veryBusyVisible: true
      }
    },
    bicycle: {
      visible: true,
      levels: {
        freeVisible: true,
        singleOrderVisible: true,
        busyVisible: true,
        veryBusyVisible: true
      }
    },
    motorcycle: {
      visible: true,
      levels: {
        freeVisible: true,
        singleOrderVisible: true,
        busyVisible: true,
        veryBusyVisible: true
      }
    },
    car: {
      visible: true,
      levels: {
        freeVisible: true,
        singleOrderVisible: true,
        busyVisible: true,
        veryBusyVisible: true
      }
    }
  },
  operationTypes: [
    OperationType.Orders,
    OperationType.Car,
    OperationType.Motorcycle,
    OperationType.Bicycle,
    OperationType.Walking
  ],
  tabSelected: 0,
  interval: undefined,

  autoRefresh: { couriers: { active: false }, orders: { active: false } }
};

const reducer: Reducer<OperationState> = (
  state: OperationState = initialState,
  action: AnyAction = { type: undefined }
) => {
  switch (action.type) {
    case GET_OPERATION_DATA:
      return { ...state, loadingOperation: true };

    case SET_OPERATION_DATA:
      return {
        ...state,
        ...action.payload,
        lastUpdateOperation: moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
      };

    case SET_BICYCLES_VISIBILITY:
    case SET_CARS_VISIBILITY:
    case SET_MOTORCYCLES_VISIBILITY:
    case SET_ORDERS_VISIBILITY:
    case SET_WALKING_VISIBILITY:
    case TOGGLE_OPERATION:
    case TOGGLE_OPERATION_AUTOREFRESH:
    case SET_COURIERS_VISIBILITY:
    case SET_OPERATION_TAB:
      return { ...state, ...action.payload };

    case GET_OPERATION_DATA_ERROR:
      return { ...state, loadingOperation: false };

    default:
      return state;
  }
};

export default reducer;
